import React, { memo } from 'react';

import { Stack } from '@/components/layout';
import { createStyles } from '@/hooks';
import { colors } from '@/theme/colors';
import UpcomingWeekRow from './row';
import type { UpcomingWeekItem } from './types';

type UpcomingWeekCardProps = {
  items: UpcomingWeekItem[];
  onItemPress?: (item: UpcomingWeekItem) => void;
};

function UpcomingWeekCard({ items, onItemPress }: UpcomingWeekCardProps) {
  const styles = useStyles();

  return (
    <Stack overflow="hidden" style={styles.root}>
      {items.map((item, index) => (
        <UpcomingWeekRow
          key={item.id}
          item={item}
          isLast={index === items.length - 1}
          onPress={onItemPress}
        />
      ))}
    </Stack>
  );
}

const useStyles = createStyles(({ scale }) => ({
  root: {
    borderRadius: scale(12),
    backgroundColor: colors['0'],
  },
}));

export default memo(UpcomingWeekCard);
